import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Input, Select } from 'antd';
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
import {SecondaryButton, TertiaryButton} from "../../../Common/button";
import messages from "./messages";
import {path, LANGUAGE} from "../../../../constant";
import "./style.less";
const { TextArea } = Input;
const Option = Select.Option;

class AuditApproveConfirmation extends Component {
  constructor(props) {
    super(props);
      this.state = {
	  loading:false,
	  status:"Active"
    };
  }


    updateStatus = () => {
	const {openStatusUpdateConfirmModal, close, data} = this.props;
	const {status, reason} = this.state;
	const {productId} = data;
	const postData = {};
	postData.status  = status;
	postData.reason = reason;
	postData.product_id = productId;
	close();
	openStatusUpdateConfirmModal(postData);
	this.setState({reason:""});
	
    }

    
    formatMessage = data => this.props.intl.formatMessage(data);

    onChangeReason = (e) => {
	this.setState({reason:e.target.value});
    }


    getOptions = () => {
	const status = {"Active":"Active", "Suspended":"Suspended"};
	let options = [];
	for (const key in status) {
	    const val = status[key];
	    
	    options.push(
		    <Option
		key={key}
		value={key}
		className="medium fontsize14"
		    >
		    {val}
		</Option>
	    );
	}

	return options;
    };


    onChangeStatus = (e) => {
	console.log(e);
	this.setState({status: e});
    };
    
   
    showStatusUI = () => {

	const {close, lang} = this.props;
	const {formatMessage, onChangeReason, getOptions, onChangeStatus} = this;
	const { status, reason } = this.state;
	
	let selectIcon;
	if(lang===LANGUAGE.ARAB){
	    selectIcon="ant-select-arrow-rtl";
	}
	else{
	    selectIcon="ant-select-arrow-ltr";
	}
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

		<div className="flex justify-content-center align-items-center mt10 bold fontsize22">
		{formatMessage(messages.statusUpdate)}
	    </div>

	    <div className="flex justify-content-center align-items-center mt10 w50 mlauto mrauto">
	    <Select
	    className={`w100 medium fontsize14 ${selectIcon}`}
	    onChange={onChangeStatus}
	    value={status}
	    dropdownStyle={{ zIndex: 2000 }}
		>
		{getOptions()}
	    </Select>
		</div>
	    
		<div className="flex justify-content-start align-items-center mt10 medium fs16 mandatory w75 mlauto">
		{formatMessage(messages.reason)}
	    </div>
		<div className="flex justify-content-center align-items-center mt10 w50 mlauto mrauto">
		<TextArea rows={4} onChange={onChangeReason} maxLength={100}/>
		</div>
		<div className="flex justify-content-center align-items-center mt20">
		<SecondaryButton
	    text={formatMessage(messages.yes)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.updateStatus}
	    disabled={!status || !reason}
		/>
		</div>
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showStatusUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(AuditApproveConfirmation);
